import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import Tooltip from '../Tooltip';

import type { CoordinatedTooltipProps } from './CoordinatedTooltip.types';
import { useCoordinatedTooltipContext } from './hooks/useCoordinatedTooltipContext';

export const CoordinatedTooltip: FC<PropsWithChildren<CoordinatedTooltipProps>> = (props) => {
  const { children, onTooltipToggle, ...tooltipProps } = props;
  const { delay, onHide, onShow } = useCoordinatedTooltipContext();

  const onToggle = (visible: boolean) => {
    if (visible) {
      onShow();
    } else {
      onHide();
    }
    onTooltipToggle?.(visible);
  };

  return (
    <Tooltip {...tooltipProps} delay={delay} onTooltipToggle={onToggle}>
      {children}
    </Tooltip>
  );
};
